// Star button for favoriting a team. Compact inline affordance that sits
// next to each team name in GameRow — kept visually quiet so it doesn't
// upstage the schedule content.

import React from "react";
import { Star } from "lucide-react";
import { toast } from "sonner";
import { useFavorites } from "@/lib/favorites";
import { useAuth } from "@/lib/auth";
import { canUse, usePaywall } from "@/lib/access";

const ACCENT = "#067647";

export default function FavoriteButton({ sport, team, testid, size = 15 }) {
  const { isFavorite, toggle } = useFavorites();
  const { user } = useAuth();
  const { openPaywall } = usePaywall();
  if (!sport || !team) return null;
  const active = isFavorite(sport, team);

  function handleClick(e) {
    e.preventDefault();
    e.stopPropagation();
    if (!canUse(user, "favorites")) {
      openPaywall("favorites");
      return;
    }
    toggle(sport, team);
    toast(active ? `Unfollowed ${team}` : `Following ${team}`, {
      description: active
        ? "They won't appear in your Favorites filter."
        : "Turn on 'Favorites only' to see just their games.",
    });
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-pressed={active}
      aria-label={active ? `Unfollow ${team}` : `Follow ${team}`}
      title={active ? `Unfollow ${team}` : `Follow ${team}`}
      data-testid={testid}
      className="inline-flex items-center justify-center p-0.5 bg-transparent border-0 cursor-pointer focus-ring align-middle"
      style={{ color: active ? ACCENT : "#bbb", lineHeight: 0 }}
    >
      <Star
        size={size}
        strokeWidth={2.4}
        fill={active ? ACCENT : "transparent"}
      />
    </button>
  );
}
